import { popScheduler } from '../util/args';
import { scheduled } from '../scheduled/scheduled';
import { fromArrayLike } from './from';
export function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    return scheduler ? scheduled(args, scheduler) : fromArrayLike(args);
}
//# sourceMappingURL=of.js.map